export type TranslationType = 'certified' | 'standard';

export interface ServiceOption {
  id: number;
  key: string;
  keys?: string[];
  label: string;
  description: string;
  price: number;
  perPageUsd?: number;
  applicableTypes: TranslationType[];
  addonsName?: string;
  addonsDescription?: string;
}

export const ALL_SERVICES: ServiceOption[] = [

  {
    id: 1,
    key: 'include_notarization',
    label: 'Notarization',
    addonsName: "Notarization",
    description: 'Get your certificate notarized to verify authenticity',
    price: 20,
    applicableTypes: ['certified'],
  },

  {
    id: 3,
    key: 'include_expedited_turnaround',
    label: 'Expedited turnaround',
    addonsName: "Expedited turnaround  — get it 2x faster",
    addonsDescription: "This option expedites  translation process not shipping",
    description: 'Get your translation delivered within 12-24 hours guaranteed',
    price: 0,
    perPageUsd: 10,
    applicableTypes: ['certified', 'standard'],
  },

  {
    id: 4,
    key: 'include_mail_hard_copy',
    keys: ['include_mail_hard_copy', 'include_2_day_shipping'],
    label: 'Mailed hard copy',
    addonsName: "Mailed hard copy —  receive a printed copy by mail   ",
    description: 'Get a hard copy of your translation by mail',
    price: 20,
    applicableTypes: ['certified'],
  },

  {
    id: 5,
    key: 'include_proofreading',
    label: 'Proofreading',
    addonsName: "Proofreading",
    description: 'After completion, an expert will proofread your translation',
    price: 0,
    perPageUsd: 12.5,
    applicableTypes: ['standard'],
  },
  {
    id: 6,
    key: 'include_desktop_publishing',
    label: 'Desktop publishing',
    addonsName: "Desktop publishing",
    description: 'Have an expert designer format your translation',
    price: 0,
    perPageUsd: 10,
    applicableTypes: ['standard'],
  },
];

export const getServicesForType = (type: TranslationType): ServiceOption[] =>
  ALL_SERVICES.filter(s => s.applicableTypes.includes(type));

export const getEffectivePrice = (service: ServiceOption, pageCount: number): number => {
  if (service.perPageUsd) {
    return service.perPageUsd * Math.max(0, pageCount);
  }
  return service.price;
};
